var _style, _path, _path2, _line, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeBodyArtWeb = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "NodeBodyArtWeb",
  x: "0px",
  y: "0px",
  viewBox: "0 0 290.7 54",
  style: {
    enableBackground: "new 0 0 290.7 54"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.staw0{fill:#071F33;}\r\n\t.staw1{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.staw2{fill:none;stroke:#50AD70;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "staw0",
  d: "M222.3,54h-63.5c-4.2,0-7.5-3.2-7.5-7V7c0-3.9,3.3-7,7.5-7h63.5c4.2,0,7.5,3.2,7.5,7v40 C229.7,50.8,226.5,54,222.3,54z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "staw0",
  d: "M130.3,54H66.9c-4.2,0-7.5-3.2-7.5-7V7c0-3.9,3.3-7,7.5-7h63.5c4.2,0,7.5,3.2,7.5,7v40 C137.7,50.8,134.5,54,130.3,54z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 238.9,
  y1: 13.8,
  x2: 6.8,
  y2: 13.8
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "staw2",
  cx: 3.9,
  cy: 13.5,
  r: 2.9
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M238,13.6c0,0-1.3-5,5.7-6.8h47"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M238,13.8c0,0-1.3,5,5.7,6.8h47"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M218.1,6.8"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M218.1,20.6"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M224.8,6.8"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M224.8,20.6"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M231.5,6.8"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M231.5,20.6"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M238.2,6.8"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  className: "staw1",
  d: "M238.2,20.6"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 244.9,
  y1: 20.6,
  x2: 244.9,
  y2: 6.8
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 251.6,
  y1: 20.6,
  x2: 251.6,
  y2: 6.8
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 258.3,
  y1: 20.6,
  x2: 258.3,
  y2: 6.8
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 265,
  y1: 20.6,
  x2: 265,
  y2: 6.8
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 271.7,
  y1: 20.6,
  x2: 271.7,
  y2: 6.8
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 278.4,
  y1: 20.6,
  x2: 278.4,
  y2: 6.8
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  className: "staw1",
  x1: 285.1,
  y1: 20.6,
  x2: 285.1,
  y2: 6.8
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeBodyArtWeb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeBodyArtWeb.5663358f.svg";
export { ForwardRef as ReactComponent };